import { report } from 'report';
import { FTUXType } from '../../Player/PlayerProperty/Progress/FTUXType';
import { AnyBoosterType, BoosterType, PreBoosterType } from './BoosterType';

export const FREE_LEVEL_ENTRY_COST = 1000;

export interface IBoosterSettings {
    localizationKey: string;
    texture: string;
    ftuxRequirement?: FTUXType;
    fallbackCoins?: number;
    fallbackLevelEntry?: number;
    iconScale?: number
}

export const BoosterDataMap: Record<AnyBoosterType, IBoosterSettings> = {
    [BoosterType.JOKER]: {
        localizationKey: 'Joker',
        texture: 'joker_reward',
        ftuxRequirement: FTUXType.JOKER,
        iconScale: 0.9,
    },
    [BoosterType.UNDO]: {
        localizationKey: 'Undo',
        texture: 'undo_reward',
        ftuxRequirement: FTUXType.UNDO,
        iconScale: 1.1,
    },
    [BoosterType.TNT]: {
        localizationKey: 'boosterTNT',
        texture: 'gas_can_reward',
        ftuxRequirement: FTUXType.TOOLBOX_UNLOCK,
        fallbackCoins: 75,
        fallbackLevelEntry: 5,
        iconScale: 0.7,
    },
    [BoosterType.SHUFFLE]: {
        localizationKey: 'boosterShuffle',
        texture: 'shuffle_reward',
        ftuxRequirement: FTUXType.SHUFFLE_BOOSTER,
        fallbackCoins: 50,
        fallbackLevelEntry: 1,
        iconScale: 0.7,
    },
    [BoosterType.BULLS_EYE]: {
        localizationKey: 'boosterBullseye',
        texture: 'bullseye-reward',
        ftuxRequirement: FTUXType.BULLSEYE_BOOSTER,
        fallbackCoins: 50,
        fallbackLevelEntry: 2,
        iconScale: 0.7,
    },
    [BoosterType.PLUS_FIVE]: {
        localizationKey: 'Plus 5 Booster',
        texture: 'shop_5_cards',
        iconScale: 0.8,
    },
    [BoosterType.PLUS_ONE]: {
        localizationKey: 'Card',
        texture: 'extra_card_reward',
        iconScale: 0.9,
    },
    [BoosterType.PLUS_THREE]: null,

    // todo implement with preBoosters
    [PreBoosterType.REMOVE_THREE]: {
        localizationKey: 'RemoveThreePreBoosterShortName',
        texture: 'booster_remove',
        fallbackCoins: 175,
        fallbackLevelEntry: 1.5,
        iconScale: 0.7,
    },
    [PreBoosterType.JOKER]: {
        localizationKey: 'JokerPreBoosterShortName',
        texture: 'booster_joker',
        fallbackCoins: 225,
        fallbackLevelEntry: 3,
        iconScale: 0.7,
    },
    [PreBoosterType.CANISTER]: {
        localizationKey: 'CanisterPreBoosterShortName',
        texture: 'booster_canister',
        fallbackCoins: 350,
        fallbackLevelEntry: 2.5,
        iconScale: 0.7,
    },
} as const;

export function getBoosterData(type: keyof typeof BoosterDataMap): IBoosterSettings {
    const data = BoosterDataMap[type];
    if (!data) {
        report('Unable to find data for given booster type', {
            once: true,
            tags: { type },
            sampleRate: 0.1,
        });
        return {
            localizationKey: 'localizationKey',
            texture: 'blank',
        };
    }
    return data;
}
